/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-23 11:57:53
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-23 16:18:39
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileDetail/config.ts
 */
export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '/settings/fileLibrary',
    name: getI18n('settings.list.fileLibrary'),
  },
  {
    url: '',
    name: getI18n('storeFileLibrary.detail.fileDetails'),
  },
];

export const IMAGE_EXT = ['apng', 'jpg', 'jpeg', 'gif', 'png', 'svg'];

export const VIDEO_EXT = ['mov', 'mp4'];
